import { Center, Spinner, Text, VStack } from "@chakra-ui/react";
import { skipToken } from "@reduxjs/toolkit/query/react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { Navigate, useParams } from "react-router-dom";
import { useGetSourcingEventQuery } from "../../../../autogen/bff-api";
import { useSub } from "../../../../common/subscription/useSub";
import { urls } from "../../../../urls";
import { isEditableInWizard } from "../../../v2/sourcing-event/changes/changeScope";
import { EditSourcingEventWizardForm } from "./EditSourcingEventWizardForm";

export const EditSourcingEventWizard = () => {
  const params = useParams();
  const { t } = useTranslation();
  const sub = useSub();

  const { data: event, isLoading, isFetching, isError, refetch } = useGetSourcingEventQuery(
    params.eventId ? { eventId: params.eventId } : skipToken
  );

  const hasSettledOnce = useRef(false);
  if (!isFetching) hasSettledOnce.current = true;

  if (!params.eventId) return <div>{t("404 event not found")}</div>;

  if (isLoading || !hasSettledOnce.current) {
    return (
      <Center h="40vh">
        <Spinner size="xl" />
      </Center>
    );
  }

  if (isError || !event) {
    return (
      <Center h="40vh">
        <VStack>
          <Text>{t("Could not load event")}</Text>
        </VStack>
      </Center>
    );
  }

  if (!isEditableInWizard(event) || !sub.canCreateEvents) {
    return <Navigate to={urls.v2.sourcingEvents.view.go(event.id)} replace />;
  }

  return <EditSourcingEventWizardForm key={event.id} eventId={event.id} event={event} refetch={refetch} />;
};
